export default __webpack_public_path__ + "static/char-20-ce7f722948ee6a038f652744b18aec6c.gif";